import { render, staticRenderFns } from "./Cikam.vue?vue&type=template&id=59e14144&scoped=true&"
import script from "./Cikam.vue?vue&type=script&lang=js&"
export * from "./Cikam.vue?vue&type=script&lang=js&"
import style0 from "./Cikam.vue?vue&type=style&index=0&id=59e14144&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e14144",
  null
  
)

export default component.exports